const ourTeamData = [
  {
    icon: require('../images/bob-belan-1.webp').default,
    title: 'Bob Belan',
    slug: 'bob-belan',
    content: 'Managing Director & Chief Executive Officer',
    ctaHref: '/about-us/our-company/bob-belan',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-bob-belan'
  },
  {
    icon: require('../images/guillaume-leger-1.webp').default,
    title: 'Guillaume Leger',
    slug: 'guillaume-leger',
    content: 'Chief Financial Officer & Executive General Manager, Finance',
    ctaHref: '/about-us/our-company/guillaume-leger',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-guillaume-leger'
  },
  {
    icon: require('../images/adriana-martinez-1.webp').default,
    title: 'Adriana Martinez',
    slug: 'adriana-martinez',
    content: 'Executive General Manager, Pay Division',
    ctaHref: '/about-us/our-company/adriana-martinez',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-adriana-martinez'
  },
  {
    icon: require('../images/steve-rubenstein-1.webp').default,
    title: 'Steve Rubenstein',
    slug: 'steve-Rubenstein',
    content: 'Executive General Manager, Money Division',
    ctaHref: '/about-us/our-company/steve-rubenstein',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-steve-rubenstein'
  },
  {
    icon: require('../images/stefano-tognon-1.webp').default,
    title: 'Stefano Tognon',
    slug: 'stefano-tognon',
    content: 'Executive General Manager, Enterprise Growth Division',
    ctaHref: '/about-us/our-company/stefano-tognon',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-stefano-tognon'
  },
  {
    icon: require('../images/felicity-joslin-1.webp').default,
    title: 'Felicity Joslin',
    slug: 'felicity-joslin',
    content:
      'Chief People Officer and Executive General Manager, People and Culture',
    ctaHref: '/about-us/our-company/felicity-joslin',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-felicity-joslin'
  },
  {
    icon: require('../images/karl-hoffman-1.webp').default,
    title: 'Karl Hoffman',
    slug: 'karl-hoffman',
    content: 'Executive General Manager, Corporate Strategy & Transformation',
    ctaHref: '/about-us/our-company/karl-hoffman',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-karl-hoffman'
  },
  {
    icon: require('../images/mark-brudenell-1.webp').default,
    title: 'Mark Brudenell',
    slug: 'mark-brudenell',
    content: 'Chief Risk Officer & Executive General Manager, Risk',
    ctaHref: '/about-us/our-company/mark-brudenell',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-mark-brudenell'
  },
  {
    icon: require('../images/campbell-morrison-1.webp').default,
    title: 'Campbell Morrison',
    slug: 'campbell-morrison',
    content:
      'Chief Operating Officer & Executive General Manager, Enterprise Services',
    ctaHref: '/about-us/our-company/campbell-morrison',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-campbell-morrison'
  },
  {
    icon: require('../images/areti-rapakousios-1.webp').default,
    title: 'Areti Rapakousios',
    slug: 'areti-rapakousios',
    content: 'Group General Manager, Internal Audit & Operational Excellence',
    ctaHref: '/about-us/our-company/areti-rapakousios',
    ctaLabel: 'View profile',
    ctaTrackId: 'our-company-leader-areti-rapakousios'
  }
];

export default ourTeamData;
